import React, { useState, useRef, useEffect } from 'react';
import './StatisticsGrid.css';

const AUTO_SCROLL_INTERVAL = 2000; // ms between news

const StatisticsGrid = () => {
  const [expandedColumn, setExpandedColumn] = useState(null);
  // Track which columns are being hovered (manual interaction)
  const [paused, setPaused] = useState([false, false, false, false]);
  const boxesRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  // Track current index for each column
  const scrollIndexes = useRef([0, 0, 0, 0]);

  const columns = [
    {
      boxes: [
        {
          image: "/images/doctor1.png",
          title: "AI-Powered Recognition",
          description: "Advanced speech recognition technology specifically designed for healthcare professionals"
        },
        {
          paragraph: "Our state-of-the-art AI technology ensures accurate and reliable speech recognition in any medical environment",
          time: "1 hour ago",
          doctor: "Dr. Emily Chen"
        },
        {
          image: "/images/blogimg2.png",
          title: "Real-time Processing",
          description: "Process and transcribe medical conversations in real-time with high accuracy"
        },
        {
          paragraph: "Genix.ai brings you the latest in healthcare AI, making your workflow seamless.",
          time: "30 minutes ago",
          doctor: "Dr. Rahul Mehta"
        },
        {
          image: "/images/doctor1.png",
          title: "Instant Updates",
          description: "Stay informed with instant updates and news in the medical field."
        }
      ]
    },
    {
      boxes: [
        {
          image: "/images/blogimg2.png",
          title: "Enhanced Efficiency",
          description: "Save valuable time with automated documentation and transcription"
        },
        {
          paragraph: "Reduce administrative burden and focus more on patient care with our intelligent automation",
          time: "2 hours ago",
          doctor: "Dr. Sarah Wilson"
        },
        {
          image: "/images/doctor1.png",
          title: "Increased Productivity",
          description: "Streamline your workflow with intelligent medical documentation"
        }
      ]
    },
    {
      boxes: [
        {
          image: "/images/doctor1.png",
          title: "Secure & Compliant",
          description: "HIPAA-compliant security measures to protect sensitive medical data"
        },
        {
          paragraph: "Enterprise-grade security protocols ensure your medical data remains private and protected",
          time: "3 hours ago",
          doctor: "Dr. Michael Brown"
        },
        {
          image: "/images/blogimg2.png",
          title: "Data Privacy",
          description: "Advanced encryption and secure data handling for medical records"
        }
      ]
    },
    {
      boxes: [
        {
          image: "/images/blogimg2.png",
          title: "Seamless Integration",
          description: "Easily integrate with existing healthcare management systems"
        },
        {
          paragraph: "Compatible with major EHR systems and healthcare platforms for smooth workflow",
          time: "4 hours ago",
          doctor: "Dr. Lisa Anderson"
        },
        {
          image: "/images/doctor1.png",
          title: "Healthcare Ecosystem",
          description: "Part of a comprehensive healthcare technology solution"
        }
      ]
    }
  ];

  // Auto-scroll effect for each column (jump to next news)
  useEffect(() => {
    const intervals = boxesRefs.map((ref, colIdx) => {
      return setInterval(() => {
        if (ref.current && !paused[colIdx]) {
          const el = ref.current;
          const statBoxes = el.querySelectorAll('.stat-box');
          if (statBoxes.length === 0) return;
          let nextIdx = scrollIndexes.current[colIdx] + 1;
          if (nextIdx >= statBoxes.length) nextIdx = 0;
          scrollIndexes.current[colIdx] = nextIdx;
          const nextBox = statBoxes[nextIdx];
          if (nextBox) {
            el.scrollTo({
              top: nextBox.offsetTop,
              behavior: 'smooth',
            });
          }
        }
      }, AUTO_SCROLL_INTERVAL);
    });
    return () => intervals.forEach(clearInterval);
  }, [paused]);

  // Handlers for pausing/resuming auto-scroll
  const handleMouseEnter = (columnIndex) => {
    setExpandedColumn(columnIndex);
    setPaused((prev) => prev.map((p, idx) => (idx === columnIndex ? true : p)));
  };
  const handleMouseLeave = (columnIndex) => {
    setExpandedColumn(null);
    setPaused((prev) => prev.map((p, idx) => (idx === columnIndex ? false : p)));
  };

  return (
    <section className="statistics-grid" id="statistics-grid">
      <h1 className="main-heading">Stay updated with Genix.ai</h1>
      <div className="statistics-container">
        {columns.map((column, columnIndex) => (
          <div 
            key={columnIndex}
            className={`statistics-column ${expandedColumn === columnIndex ? 'expanded' : ''}`}
            onMouseEnter={() => handleMouseEnter(columnIndex)}
            onMouseLeave={() => handleMouseLeave(columnIndex)}
          >
            <div
              className="boxes-container"
              ref={boxesRefs[columnIndex]}
              tabIndex={0}
              style={{ cursor: 'grab' }}
            >
              {column.boxes.map((box, boxIndex) => (
                <div key={boxIndex} className="stat-box">
                  {box.image ? (
                    <>
                      <img src={box.image} alt={box.title} />
                      <h3>{box.title}</h3>
                      <p>{box.description}</p>
                    </>
                  ) : (
                    <>
                      <p className="paragraph-only">{box.paragraph}</p>
                      <div className="time-doctor-info">
                        <span className="time">{box.time}</span>
                        <span className="doctor">{box.doctor}</span>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatisticsGrid; 